import FileTextOutlined from '@ant-design/icons/FileTextOutlined';
import { useTranslation } from 'react-i18next';
import type { Citation } from '@/api/runs';
import styles from './conversation.module.css';

/**
 * The numbered sources at the end of an answer: number, name and location
 * when one exists (the answer body does not repeat names, spec §5).
 */
const SourceList = ({
  citations,
  onOpen,
}: {
  citations: Citation[];
  onOpen: (citation: Citation, opener: HTMLElement) => void;
}) => {
  const { t } = useTranslation();
  const sorted = [...citations].sort((a, b) => Number(a.n) - Number(b.n));
  return (
    <section className={styles.sources} data-testid="answer-sources">
      <h4 className={styles.sourcesTitle}>{t('v2.messages.sources')}</h4>
      <ol className={styles.sourceItems}>
        {sorted.map(citation => {
          const name = citation.name ?? t('v2.sources.unavailable');
          return (
            <li key={citation.n}>
              <button
                type="button"
                className={styles.source}
                title={name}
                aria-label={t('v2.messages.citeLabel', {
                  n: citation.n,
                  name: [name, citation.location].filter(Boolean).join(' · '),
                })}
                onClick={event => onOpen(citation, event.currentTarget)}
              >
                <span className={styles.sourceNumber}>{citation.n}</span>
                <FileTextOutlined aria-hidden />
                <span className={styles.sourceName}>{name}</span>
                {citation.location ? (
                  <span className={styles.sourceLocation}>
                    {citation.location}
                  </span>
                ) : null}
              </button>
            </li>
          );
        })}
      </ol>
    </section>
  );
};

export default SourceList;
